import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { AppConst, APP_CONSTANT } from 'src/app/core/_constants/app.constant';
import { RouteConstant } from 'src/app/core/_constants/route.constant';
import { LocalStorageProvider } from 'src/app/core/_services/common/storage.service';
import { PagesService } from 'src/app/core/_services/pages/pages.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  validationErrorMessage= APP_CONSTANT.VALIDATION
  submitted:Boolean=false;
  alertType:any;
  showAlert = false;
  public forgotPasswordForm: FormGroup
  alertMsg: any;
  constructor(private router : Router,private fb: FormBuilder,private service: PagesService, private loader: NgxUiLoaderService, private toastr: ToastrService, private storageService: LocalStorageProvider) {
    this.forgotPasswordForm = this.createForm()
   }

  ngOnInit(): void {
  }
  createForm(){
    return this.fb.group({
      email: ['',[Validators.required, Validators.email,Validators.pattern(AppConst.EMAIL_PATTERN)]]
    })
  }

  get f(){
    return this.forgotPasswordForm.controls
  }
  submit(body:any){
    this.submitted=true;
    if(this.forgotPasswordForm.valid){
      this.loader.start();
      this.service.post(body,`${API_ROUTES.ACCOUNT.forgetPassword}`).pipe().subscribe(response => {
        this.loader.stop();
        if(response.status){
          this.alertType = 'success';
          this.alertMsg = APP_CONSTANT.FORGOTPASSWORD.successMsg;
          // this.storageService.setItem('Email',body.email);
        }else{
          this.alertType = 'error';
          this.alertMsg = response.msg;
        }
        this.showAlert = true;
      })
    }

  }


}
